import { render, staticRenderFns } from "./checklistField.vue?vue&type=template&id=54a4158e&scoped=true&lang=pug&"
import script from "./checklistField.vue?vue&type=script&setup=true&lang=js&"
export * from "./checklistField.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./checklistField.vue?vue&type=style&index=0&id=54a4158e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a4158e",
  null
  
)

export default component.exports